export function validateMobile(val) {
  const length = val.length;
  var mobile = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
  return length == 11 && mobile.test(val)
}


export function validateEmail(val) {
  var mobile = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
  return mobile.test(val)
}
// 验证密码
export function validatePassword(val) {
  var password = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/;
  return password.test(val)
}

export function getTime(startDate) {
  var startDateTemp = startDate.split(" ");
  var arrStartDate = startDateTemp[0].split("-");
  var arrStartTime = startDateTemp[1].split(":");
  var allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2], arrStartTime[0], arrStartTime[1], arrStartTime[2]).getTime();
  return allStartDate
}

//验证身份证18位
export function vaildateIDCard(val) {
  let IDCard = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  return IDCard.test(val);
}

//验证营业执照
export function ivaildateBLCard(val) {
  let BLCard = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/;
  return BLCard.test(val);
}

//验证手机号
export function verificationpPhone(val){
  let BLCard = /^1[3456789]\d{9}$/;
  return BLCard.test(val);
}
//验证邮箱
export function verificationpMailbox(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let BLCard = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  return BLCard.test(val);

}
//验证姓名
export function verificationpName(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let Name = /^([\·]*[\u4e00-\u9fa5]){2,9}$/;
  return Name.test(val);
}
//验证身份证号
export function verificationpIdCard(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let IdCard = /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|2010)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/;
  return IdCard.test(val);
}
//验证营业执照
export function regexBusinessLicense(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let reg =/(^[a-zA-Z0-9_-]{15}$)|(^[a-zA-Z0-9_-]{18}$)/;
  return reg.test(val);
}
// 固定电话
export function regexFixedTele(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let reg =/^0?(13[0-9]|15[012356789]|17[013678]|18[0-9]|14[57])[0-9]{8}$/;
  return reg.test(val);
}
// 传真电话ad
export function regexFaxTele(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let reg =/(^(\d{3,4}-)?\d{7,8})$|^((1[0-9][0-9]\d{8}$))/;
  return reg.test(val);
}
//邮政编码
export function regexPostCode(val){
  // let BLCard = /^([a-zA-Z]|[0-9])\w(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  let reg =/^[0-9]{6}$/;
  return reg.test(val);
}